import img from '@i/global/slogan.png'

const ContentLayout = () => {
  return (
    <div className="m-auto w-1200px">
      <img className="my-4 h-101px w-259px" src={img} />
      <div className="px-3">
        <Outlet />
      </div>
    </div>
  )
}
export default ContentLayout
